import React from 'react'
import _size from 'lodash/size'
import { URL_TERMS_PRIVACY } from '../../services/url/constants'
import { stringify as stringifyQuery } from '../../services/query-string/index'
import { TARGET_BLANK } from '../Link/constants'
import Link from '../Link/index'

/**
 * @param {Object} props - The props
 * @param {Map} props.staticText - The static text data
 * @param {Object} props.location - The option click handler
 * @param {boolean} props.isGdpr - The value indicating if the terms
 * link is rendered for a GDPR country
 * @returns {JSX.Element} The PrivacyTerms component
 */

function PrivacyTerms ({
  staticText,
  location,
  isGdpr,
}) {
  // use query to retain language when opening link in a new tab
  const { query } = location
  const privacyUrl = `${URL_TERMS_PRIVACY}${_size(query) > 0 ? `?${stringifyQuery(query)}` : ''}`

  return isGdpr
    ? (
      <span>
        {`${staticText.get('termsLabelStart')} ` }
        <Link
          directLink
          to={privacyUrl}
          target={TARGET_BLANK}
          // eslint-disable-next-line jsx-a11y/tabindex-no-positive
          tabIndex="8"
        >
          {staticText.get('termsLink')}
        </Link>
        {` ${staticText.get('termsLabelEnd')}`}
      </span>
    )
    : (
      <p className="account-create-form__terms-privacy">
        {`${staticText.get('nonGdprTermsTextStart')} `}
        <Link
          directLink
          to={privacyUrl}
          target={TARGET_BLANK}
        >
          {staticText.get('nonGdprTermsTextLink')}
        </Link>
        {` ${staticText.get('nonGdprTermsTextEnd')}`}
      </p>
    )
}

export default PrivacyTerms
